import moment from 'moment';

import { ACTIONS } from '../Constants';
import { VerbFetch } from '../VerbFetch';

export * from './Abilities';
export * from './Admin';
export * from './AlgoliaSearch';
export * from './Announcements';
export * from './AssetReviewItems';
export * from './auth';
export * from './Badges';
export * from './Behaviors';
export * from './Billing';
export * from './Bookmarks';
export * from './Collections';
export * from './Comments';
export * from './Companies';
export * from './Coupons';
export * from './Dimensions';
export * from './Email';
export * from './Files';
export * from './FurtherLearningCollections';
export * from './GlobalContentRows';
export * from './GlobalSectionItems';
export * from './Images';
export * from './Language';
export * from './LearningAssets';
export * from './LearningFrameworks';
export * from './LocalStorage';
export * from './MediaLibrary';
export * from './Mobile';
export * from './Modal';
export * from './Navigation';
export * from './Notes';
export * from './Notifications';
export * from './ParticipantsSearch';
export * from './Pathways';
export * from './PeerRecommendations';
export * from './PrivacyRequests';
export * from './Reactions';
export * from './Search';
export * from './SegmentEvents';
export * from './Settings';
export * from './SuppressionData';
export * from './Surveys';
export * from './Teams';
export * from './UserCollections';
export * from './UserEvents';
export * from './UserFeedback';
export * from './UserLearningAssets';
export * from './UserPathways';
export * from './UserProfiles';
export * from './UserResponses';
export * from './UserSurveyData';
export * from './UserWelcomeAssets';
// export * from './FeedbackGroupResponses';
export * from './Welcome';
export * from './WelcomeAssets';
export * from './Workspace';

export const getVersion = (params) => (dispatch) => {
    const { pathsContext } = params;
    return VerbFetch(`${pathsContext.adminServerUrl}/version`).then((body) => {
        dispatch({
            type: ACTIONS.GET_VERSION,
            payload: body
        });
    });
};

export const inviteUsers = (params) => (dispatch) => {
    const { pathsContext, ...rest } = params;
    return VerbFetch(`${pathsContext.adminServerUrl}/email/userinvites`, {
        method: 'POST',
        body: rest
    }).then((body) => {
        dispatch({
            type: ACTIONS.INVITE_USERS,
            payload: body
        });
    });
};

export const inviteUsersCustom = (params) => (dispatch) => {
    const { pathsContext, ...rest } = params;
    return VerbFetch(`${pathsContext.adminServerUrl}/email/custominvites`, {
        method: 'POST',
        body: rest
    }).then((body) => {
        dispatch({
            type: ACTIONS.INVITE_USERS,
            payload: body
        });
        return body;
    });
};

export const inviteEmployees = (params) => (dispatch) => {
    const { pathsContext, ...rest } = params;
    return VerbFetch(`${pathsContext.adminServerUrl}/email/employeeinvites`, {
        method: 'POST',
        body: rest
    }).then((body) => {
        dispatch({
            type: ACTIONS.INVITE_EMPLOYEES,
            payload: body
        });
        return body;
    });
};

export const _dwelled = ({ objectId, objectType, trackEventId, optionalItems = {} }) => ({
    type: ACTIONS.DWELLED,
    trackEventId,
    payload: {
        objectId,
        objectType,
        ...optionalItems,
        lastDwellTime: moment()
            .utc()
            .format()
    }
});

export const sendDwelled = ({ objectId, objectType, trackEventId, optionalItems }) => (dispatch) =>
    dispatch(_dwelled({ objectId, objectType, trackEventId, optionalItems }));

export const shared = ({ objectId, objectType, shareType }) => ({
    type: ACTIONS.SHARED,
    payload: {
        objectId,
        objectType,
        shareType
    }
});

export const sessionStart = () => ({
    type: ACTIONS.SESSION_START
});

export const closeTab = () => ({
    type: ACTIONS.CLOSE_TAB
});

export const buttonClick = (name, meta = {}) => ({
    type: ACTIONS.BUTTON_CLICK,
    payload: {
        ...meta,
        name
    }
});

export const linkClick = (path, meta = {}) => ({
    type: ACTIONS.LINK_CLICK,
    payload: {
        ...meta,
        path
    }
});
